import { TireList } from "@/@types/Tire";
import { ApiClient } from "../../ApiClient";
import { GetTireListResponse } from "../schema/GetTireListResponse";
import { mapTireList } from "../../mappers/tireListMapper";

export const getTireListBySearch = async (searchTitle: string, industrySlug?: string): Promise<TireList> => {
    const client = ApiClient.getInstance()

    industrySlug && (searchTitle = `${industrySlug}/&industrySlug=${searchTitle}`)

    const response = await client.get<GetTireListResponse>(`tires/by-search-bar?title=${searchTitle}`)

    const mappedResponse = mapTireList(response)

    return mappedResponse;
}